import React from 'react';
import { useNavigate } from 'react-router-dom';  // Utilisation de useNavigate
import './Button.css';

const ButtonRedirect = ({ url, texte }) => {
  const navigate = useNavigate();  // Pour la navigation interne

  const handleRedirect = () => {
    // Vérifier si l'URL est définie et si elle commence par 'http' ou 'https'
    if (url && (url.startsWith('http') || url.startsWith('https'))) {
      // Si l'URL est externe, ouvrir dans un nouvel onglet
      window.open(url, '_blank');
    } else if (url) {
      // Si l'URL est interne, utiliser useNavigate pour naviguer
      navigate(url);
    } else {
      console.error("L'URL est manquante ou invalide", url);
    }
  };

  return (
    <button onClick={handleRedirect} className='button'>
      {texte}
    </button>
  );
};

export default ButtonRedirect;